import React, { useState } from 'react';
import { FaFireAlt } from 'react-icons/fa';
import { FaFireFlameSimple } from 'react-icons/fa6';
import { BsFire } from 'react-icons/bs';
import { FaExclamationCircle } from 'react-icons/fa';
import { FaLongArrowAltDown } from 'react-icons/fa';
import { FaLongArrowAltUp } from 'react-icons/fa';
import moment from 'moment';
import { Button } from 'react-bootstrap';

export const DetailedFireDangerDay = ({ data, index }) => {
  const [expanded, setExpanded] = useState(true);

  const fireIcons = {
    0: <FaFireFlameSimple size={64} />,
    1: <FaFireAlt size={64} />,
    2: <BsFire size={64} />,
    3: <BsFire size={64} />,
    4: <BsFire size={64} />,
  };

  return (
    <div className="d-flex flex-column border-light-subtle">
      <div className="h4 flex-row border-bottom border-1 border-light-subtle d-flex justify-content-between">
        <div>{moment(data[0].utc_time).format('MM/DD/YYYY')}</div>
        <div>{data[0]['level']}</div>
      </div>
      <div className="d-flex flex-wrap flex-row justify-content-between">
        {expanded &&
          data.map((data, index) => {
            return (
              <div key={index} className="p-3 d-flex justify-content-between w-100 w-lg-50">
                <div>
                  <div className="h5 fw-bold">{data.timeOfDay}</div>
                  <div className="mt-2">
                    <FaExclamationCircle /> {data['level']}
                  </div>
                  <div className="mt-2">
                    <FaLongArrowAltUp /> Upper Soil Moisture: {data['upper_soil_moisture']}
                  </div>
                  <div className="mt-2">
                    <FaLongArrowAltDown /> Lower Soil Moisture: {data['lower_soil_moisture']}
                  </div>
                </div>
                <div className="mt-2">{fireIcons[data['danger_level']]}</div>
              </div>
            );
          })}
      </div>
    </div>
  );
};
